// 9fbef606107a605d69c0edbcd8029e5d
import createValidateMethod from '@tcp/core/src/utils/formValidation/createValidateMethod';
import getStandardConfig from '@tcp/core/src/utils/formValidation/validatorStandardConfig';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { setSessionStorage } from '../../../../../../../utils';
import { isPickuOrderStatus } from '../../../../BagPage/container/BagPage.selectors';
import { scrollToFirstError } from '../../../../Checkout/util/utility';
import { setShippingFormValuesInSS } from '../../../container/Shipping/Shipping.utils';
import { updateSectionState } from '../../../container/SinglePageCheckout.actions';
import { SPC_SECTION } from '../../../container/SinglePageCheckout.constants';
import { setContactFormValuesInSS } from '../../ContactForm/ContactForm.util';
import PickupDetailsForm from './PickupDetailsForm.view';

export const getInitialValues = (ownProps) => {
  const {
    pickUpContactPerson,
    pickUpAlternatePerson,
    isHasPickUpAlternatePerson,
    getShippingAddress,
    contactFormValuesFromSS: { phoneNumber, smsSignUp, emailSignUp },
    emailAddressFromSS: { emailAddress: emailAddressInSS, phoneCountryCode },
  } = ownProps;
  const { userFirstName, userLastName } = ownProps;
  return {
    firstName: pickUpContactPerson?.firstName || userFirstName || getShippingAddress?.givenName,
    lastName: pickUpContactPerson?.lastName || userLastName || getShippingAddress?.familyName,
    addAltPersonSwitch: isHasPickUpAlternatePerson,
    firstName_alt: pickUpAlternatePerson?.firstName,
    lastName_alt: pickUpAlternatePerson?.lastName,
    emailAddress_alt: pickUpAlternatePerson?.emailAddress,
    phoneNumber:
      pickUpContactPerson?.phoneNumber || phoneNumber || getShippingAddress?.phoneNumber || '',
    smsSignUp: smsSignUp || false,
    emailSignUp,
    emailAddress: pickUpContactPerson?.emailAddress || emailAddressInSS || '',
    phoneCountryCode:
      pickUpContactPerson?.phoneCountryCode ||
      getShippingAddress?.phoneCountryCode ||
      phoneCountryCode ||
      '+1',
  };
};

const PickupForm = (props) => {
  const {
    formName,
    formSection,
    section,
    isHasPickUpAlternatePerson,
    pickupFormInput,
    smsSignUpLabels,
    isUsSite,
    emailSignUpFlags,
    emailSignUpLabels,
    emailSignUpCaRichText,
    isChildrenPalace,
    isGymboree,
    isSnJ,
    isBossBopisOrder,
    initialValues,
    isLoginV2FlowEnabled,
    savedEmail,
    emailFailSafe,
    venmoStatus,
    pageCategory,
    isPlccIC,
    orderTrackingEnhancementEnabled,
    dispatchFormFieldChange,
    setPhoneCountryAction,
    isInternationalPhoneNumberEnabled,
  } = props;
  return (
    <PickupDetailsForm
      formName={formName}
      section={section}
      formSection={formSection}
      addAltPersonSwitch={pickupFormInput?.addAltPersonSwitch}
      isHasPickUpAlternatePerson={isHasPickUpAlternatePerson}
      smsSignUpLabels={smsSignUpLabels}
      isUsSite={isUsSite}
      emailSignUpFlags={emailSignUpFlags}
      emailSignUpLabels={emailSignUpLabels}
      emailSignUpCaRichText={emailSignUpCaRichText}
      isSnJ={isSnJ}
      isGymboree={isGymboree}
      isChildrenPalace={isChildrenPalace}
      isBossBopisOrder={isBossBopisOrder}
      initialValues={initialValues}
      isLoginV2FlowEnabled={isLoginV2FlowEnabled}
      savedEmail={savedEmail}
      emailFailSafe={emailFailSafe}
      venmoStatus={venmoStatus}
      pageCategory={pageCategory}
      isPlccIC={isPlccIC}
      orderTrackingEnhancementEnabled={orderTrackingEnhancementEnabled}
      dispatchFormFieldChange={dispatchFormFieldChange}
      setPhoneCountryAction={setPhoneCountryAction}
      isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
    />
  );
};

const setPayloadForPickup = (emailAddressFromShipping, emailAddress, props) => {
  const { userEmail, savedEmail, emailFailSafe, venmoStatus, isLoginV2FlowEnabled } = props;
  let pickupPayload = '';
  if (isLoginV2FlowEnabled && (!savedEmail || emailFailSafe || venmoStatus)) {
    pickupPayload = { email: emailAddress || userEmail || emailAddressFromShipping };
    setContactFormValuesInSS({ emailAddress });
    if (!savedEmail) {
      setSessionStorage({ key: 'emailForFailSafe', value: true });
    }
  }
  return pickupPayload;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const onSubmit = (values, dispatch, props) => {
  const {
    updateStoreDetails,
    getPickupFormData,
    userEmail,
    userPhone,
    activateSpcSection,
    isLoginV2FlowEnabled,
    shippingContactInfo,
    orderTrackingEnhancementEnabled,
    smsCheckBoxState,
  } = props;
  let smsInfo = getPickupFormData?.smsSignUp?.sendOrderUpdate;
  if (orderTrackingEnhancementEnabled) {
    smsInfo = smsCheckBoxState;
  }
  const { emailAddress: emailAddressFromShipping } = shippingContactInfo || {};
  const { smsSignUp, emailSignUp, phoneNumber, emailAddress } = getPickupFormData;
  const vibesSmsPhoneNo = smsInfo ? phoneNumber : '';
  let payload = {};
  const emailPayload = setPayloadForPickup(emailAddressFromShipping, emailAddress, props);
  if (getPickupFormData?.addAltPersonSwitch === true) {
    payload = {
      firstName: getPickupFormData?.firstName,
      lastName: getPickupFormData?.lastName,
      phone: isLoginV2FlowEnabled ? getPickupFormData?.phoneNumber : userPhone,
      c_altName: getPickupFormData?.firstName_alt
        ? `${getPickupFormData?.firstName_alt} ${getPickupFormData?.lastName_alt}`
        : '',
      c_altFirstName: getPickupFormData?.firstName_alt,
      c_altLastName: getPickupFormData?.lastName_alt,
      c_altEmail: getPickupFormData?.emailAddress_alt,
      email: userEmail,
      c_vibesSmsPhoneNo: vibesSmsPhoneNo,
      phoneCountryCode: getPickupFormData?.phoneCountryCode,
    };
    if (isLoginV2FlowEnabled) {
      payload = {
        ...payload,
        smsSignUp: { sendOrderUpdate: smsInfo },
        emailSignUp,
        ...emailPayload,
      };
    }
  } else {
    payload = {
      firstName: getPickupFormData?.firstName,
      lastName: getPickupFormData?.lastName,
      phone: isLoginV2FlowEnabled ? getPickupFormData?.phoneNumber : userPhone,
      email: userEmail || emailAddressFromShipping,
      c_vibesSmsPhoneNo: vibesSmsPhoneNo,
      phoneCountryCode: getPickupFormData?.phoneCountryCode,
    };
    if (isLoginV2FlowEnabled) {
      payload = {
        ...payload,
        smsSignUp: { sendOrderUpdate: smsInfo },
        emailSignUp,
        ...emailPayload,
      };
    }
  }
  updateStoreDetails({ ...payload, isUpdating: true });
  activateSpcSection();
  if (isLoginV2FlowEnabled) {
    setShippingFormValuesInSS({
      smsSignUp: { sendOrderUpdate: smsInfo },
      emailSignUp,
      phoneNumber,
    });
    updateSectionState({
      id: SPC_SECTION.SHIPPING,
      section: { smsSignUp, emailSignUp, phoneNumber },
    });
  }
};

PickupForm.propTypes = {
  formName: PropTypes.string.isRequired,
  formSection: PropTypes.string,
  pickupFormInput: PropTypes.shape({ addAltPersonSwitch: false }),
  section: PropTypes.shape({}).isRequired,
  isHasPickUpAlternatePerson: PropTypes.bool.isRequired,
  isLoginV2FlowEnabled: PropTypes.bool,
};

PickupForm.defaultProps = {
  formSection: '',
  pickupFormInput: {},
  isLoginV2FlowEnabled: false,
};

const mapStateToProps = (state, ownProps) => {
  return {
    form: ownProps?.formName,
    initialValues: getInitialValues(ownProps),
    isBossBopisOrder: isPickuOrderStatus(state),
  };
};

const validateMethod = createValidateMethod(
  getStandardConfig([
    'firstName',
    'lastName',
    'firstName_alt',
    'lastName_alt',
    'emailAddress_alt',
    'phoneNumber',
    'emailAddress',
  ])
);

const Submiterror = (errors, dispatch, submitError, props) => {
  scrollToFirstError(errors);
  props.clickedOutsideShipping(true);
  setTimeout(() => props.clickedOutsideShipping(false), 1000);
};

export default connect(mapStateToProps)(
  reduxForm({
    onSubmit,
    ...validateMethod,
    // destroyOnUnmount: false,
    onSubmitFail: Submiterror,
  })(PickupForm)
);
export { PickupForm as ShippingFormVanilla };
